.companyPadding {
  @media (--lg) {
    padding-bottom: 130px !important;
  }
}
